// @flow

/**
 * Checks if the browser is running in Playwright.
 */
export const isPlaywright = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  if (window.navigator.webdriver === true) {
    return true;
  }

  return false;
};
